export interface RowAuthority {
    id: number;
    domain: any;
    domainDisplayName: string;
    name: string;
    displayName: string;
    selected?: boolean;
}

export function selectedAuthorityIdsFromProfile(
    items: Array<{authority?: {id?: number | string} | null}> | null | undefined
): number[] {
    if (!Array.isArray(items)) {
        return [];
    }
    const ids: number[] = [];
    for (const item of items) {
        const rawId = item?.authority?.id;
        if (rawId === null || rawId === undefined || rawId === '') {
            continue;
        }
        const id = Number(rawId);
        if (!Number.isNaN(id) && !ids.includes(id)) {
            ids.push(id);
        }
    }
    return ids;
}

export function mergeVisibleSelection(
    previouslySelectedIds: number[],
    visibleRowIds: number[],
    visibleSelectedIds: number[]
): number[] {
    const visible = new Set(visibleRowIds.map(Number));
    const hiddenSelected = previouslySelectedIds.filter((id) => !visible.has(Number(id)));
    const nextVisible = visibleSelectedIds.map(Number);
    const merged = hiddenSelected.concat(nextVisible);
    return merged.filter((id, index) => merged.indexOf(id) === index);
}

export function mapCatalogToRows(
    catalog: Array<{
        id: number;
        name: string;
        displayName: string;
        domain?: {displayName?: string} | null;
    }>,
    selectedIds: number[]
): RowAuthority[] {
    const selected = new Set(selectedIds.map(Number));
    return catalog.map((authority) => ({
        id: authority.id,
        domain: authority.domain,
        domainDisplayName: authority.domain?.displayName ?? '',
        name: authority.name,
        displayName: authority.displayName,
        selected: selected.has(Number(authority.id)),
    }));
}

export function rowsForSave(rows: RowAuthority[], selectedIds: number[]): RowAuthority[] {
    const selected = new Set(selectedIds.map(Number));
    return rows.filter((row) => selected.has(Number(row.id)));
}
